// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"8868218f","453":"aac68abc","474":"7d00b9c8","669":"2764dfff","796":"a0e91d56","829":"e488c2ec"}[chunkId] + ".chunk.js";
};